<script setup lang="ts">
import type { NuxtError } from "#app";

defineProps({
  error: Object as () => NuxtError,
});
</script>

<template>
  <NuxtLayout name="default">
    <div class="mt-20 flex flex-col items-center">
      <NuxtIcon
        name="mdi:question-mark-circle-outline"
        class="mt-20 mb-10 w-30 h-30 text-neutral-300" />
      <h1
        class="mx-auto max-w-2xl text-center text-8xl font-bold tracking-tight text-secondary-500">
        404
      </h1>
      <h2
        class="mx-auto max-w-2xl text-center text-4xl font-bold tracking-tight text-neutral-200">
        {{ $t("main.notFound404.pageNotFound") }}
      </h2>
      <p
        class="mx-auto mt-2 max-w-sm px-2 text-center text-base text-neutral-300">
        {{ $t("main.notFound404.resourceNotFound") }}
      </p>
      <DevOnly>
        <p class="mx-auto mt-8 max-w-xl text-center text-base text-zinc-500">
          {{ error?.statusCode }} {{ error?.message }}
        </p>
      </DevOnly>
      <div
        class="mt-6 mx-auto max-w-2xl text-center flex items-center justify-center">
        <NuxtLinkLocale to="/">
          <BaseButtonSubmit
            :text="$t('main.notFound404.backToHomepage')"
            data-test="button-page-404-to-homepage"
            size="xl" />
        </NuxtLinkLocale>
      </div>
    </div>
  </NuxtLayout>
</template>
